import { Text } from '$components'
import { ReactNode } from 'react'

export type SidebarGroupProps = {
  title: string,
  children: ReactNode
}

export function SidebarGroup({ title, children }: SidebarGroupProps) {
  return (
    <div className="mb-stack-section">
      <Text
        as="h3"
        type="xs"
        className="uppercase text-fg-subtle px-stack mb-stack-tight"
      >
        { title }
      </Text>

      <div className="flex flex-col gap-stack-dense">
        { children }
      </div>
    </div>
  )
}
